import React from 'react';
import LocationTemplate from './LocationTemplate';

const SnowHillPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Snow Hill"
      stateName="North Carolina"
      countyName="Greene"
      zipCodes={["28580"]}
      latitude={35.4513}
      longitude={-77.6822}
      population={1526}
      historicalFact="Incorporated in 1855, named for the occasional snowfalls that looked prominent on a hill near the town."
      nearbyTowns={[
        "Kinston, NC",
        "Hookerton, NC",
        "Farmville, NC",
        "Stantonsburg, NC",
        "Ayden, NC",
        "Winterville, NC",
        "Grifton, NC",
        "La Grange, NC"
      ]}
    />
  );
};

export default SnowHillPage;